import React from 'react';
import { defineMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Avatar, AvatarType } from '@daedalus/atlas/Avatar';
import { getUserName } from '@daedalus/core/src/auth/business/authentication';
import { getUser } from '@daedalus/core/src/auth/modules/selectors';
import { VioDealTag } from '../../../privateDeal/VioDealTag';
type Props = {
  hasBottomIcon?: boolean;
};
const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "i1vo8uvi",
  propsAsIs: false
});
const AvatarWrapper = /*#__PURE__*/styled('div')({
  name: "AvatarWrapper",
  class: "a12yzgnf",
  propsAsIs: false
});
const getAvatarType = (picture?: string): AvatarType => (picture ? AvatarType.Picture : AvatarType.Icon) as AvatarType;
export const ProfilePicture = ({
  hasBottomIcon = true
}: Props) => {
  const user = useSelector(getUser);
  const profilePicture = user?.attributes?.picture;
  const message = defineMessage({
    id: 'vioDeals.member',
    defaultMessage: 'Vio Member'
  });
  return <ImageContainer>
      <AvatarWrapper>
        <Avatar picture={profilePicture} name={getUserName(user)} size="lg" type={getAvatarType(profilePicture)} borderColorPath="border.special.c300" bottomIcon={hasBottomIcon ? <VioDealTag message={message} /> : undefined} />
      </AvatarWrapper>
    </ImageContainer>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");